import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Container } from '../../../base/Container'
import AppToaster from '../../../commonLib/AppToaster'
import { loadingMiniContext } from '../../../commonLib/lodingMiniContext'
import { loadingContext } from '../../../commonLib/_lodingContext'
import *as productProcessingDistributionCrud from '../../../_crud/productProcessingDistributionCrud'
import { TimelineHistory } from '../../Global/TimelineHistory'
import { ProcessingDistributionItemView } from './ProcessingDistributionItemView'


export function ProcessingDistributionDashBoard(){
    const [isLoading, setIsLoading] = useContext(loadingContext)
    const [processingDistribution, setProcessingDistribution] = useState()
    const { id } = useParams()

    function doRefresh() {
        getData()
    }

    useEffect(() => {
        getData()
    }, []);


    function getData() {
        setIsLoading(true);
        productProcessingDistributionCrud.GetById(id)
            .then(res => {
                if (res.data.data) {
                    if (res.data.result.succeeded) {
                        let hdata = res.data.data
                        setProcessingDistribution(hdata);
                        setIsLoading(false)
                    }
                    else {
                        setIsLoading(false)
                        setProcessingDistribution();
                    }
                }
                else {
                    setIsLoading(false)
                    setProcessingDistribution();
                    AppToaster("Server Error /Invalid Try.", 'error')
                }
            })
            .catch(error => {
                setIsLoading(false);
                AppToaster(error, 'error')
            })
    }
    return (
        <Container title="Processing Distribution Dashboard" doRefresh={doRefresh} isBack="true" >

            <div className="row">
                <div className="col-lg-8">
                <ProcessingDistributionItemView processingDistribution={processingDistribution} />
                </div>
                <div className="col-lg-4">
                    <TimelineHistory id={id} type={4} pageSize={10} text="Processing Distribution Timeline" />
                </div>

            </div>
        </Container >
    )
}

